'use strict';

function NonResidentialCareTypeFactory(constants, numberUtils, kirkleesCareAssessmentService, careAssessmentService) {

  function NonResidentialCareType(userInputModel) {

    this.getTotalWeeklyExpenses = function () {

      return ['rent', 'councilTax', 'mortgage'].reduce(function (runningTotal, expenseType) {
        return runningTotal + userInputModel.getWeeklyExpense(expenseType);
      }, 0);
    };

    function getEffectiveAgeLevel(results) {
      var effectiveAgeLevel = constants.levels.low;
      var userTypes = constants.userTypes;

      var applicantAgeLevel = results[userTypes.user].ageLevel;

      if (userInputModel.isCouple()) {
        var partnerAgeLevel = results[userTypes.partner].ageLevel;

        if (partnerAgeLevel === constants.levels.medium || applicantAgeLevel === constants.levels.medium) {
          effectiveAgeLevel = constants.levels.medium;
        }

        if (partnerAgeLevel === constants.levels.high || applicantAgeLevel === constants.levels.high) {
          effectiveAgeLevel = constants.levels.high;
        }
      } else {
        effectiveAgeLevel = applicantAgeLevel;
      }

      return effectiveAgeLevel;
    }

    function getEffectiveDisabilityLevel(results, userType) {
      var effectiveDisabilityLevel = constants.levels.low;
      var userTypes = constants.userTypes;

      var applicantData = userInputModel.getApplicantData();
      var applicantDisabilityLevel = kirkleesCareAssessmentService.getDisabilityLevel(applicantData);

      if (userInputModel.isCouple()) {
        var partnerData = userInputModel.getPartnerData();
        var partnerDisabilityLevel = kirkleesCareAssessmentService.getDisabilityLevel(partnerData);

        console.log('actual partner disability level', partnerDisabilityLevel);

        if (partnerDisabilityLevel === constants.levels.medium || applicantDisabilityLevel === constants.levels.medium) {
          effectiveDisabilityLevel = constants.levels.medium;
        }

        if (partnerDisabilityLevel === constants.levels.high || applicantDisabilityLevel === constants.levels.high) {
          effectiveDisabilityLevel = constants.levels.high;
        }
      } else {
        effectiveDisabilityLevel = applicantDisabilityLevel;
      }

      return effectiveDisabilityLevel;
    }

    this.getAllowableWorkingTaxCredit = function (workingTaxCreditIncome) {
      return 0;
    };

    this.getPartnerMinimumIncomeGuarantee = function (results) {
      var ageLevel = getEffectiveAgeLevel(results);
      var disabilityLevel = getEffectiveDisabilityLevel(results);

      var plaTable = constants.personalLivingAllowance.partnerNonResidential;

      console.log("Partner MIG age category", ageLevel, ", Partner MIG disability category", disabilityLevel);
      return careAssessmentService.searchPlaTable(plaTable, ageLevel, disabilityLevel) / 2;
    };

    this.personalLivingAllowance = function (results) {
      var ageLevel = getEffectiveAgeLevel(results);
      var disabilityLevel = getEffectiveDisabilityLevel(results);
      console.log("PLA age category", ageLevel, ", PLA disability category", disabilityLevel);

      var plaTables = constants.personalLivingAllowance;
      var plaTable = userInputModel.isCouple() ? plaTables.coupleServiceUser : plaTables.singleServiceUser;
      var totalPLA = careAssessmentService.searchPlaTable(plaTable, ageLevel, disabilityLevel);
      console.log("PLA table lookup", totalPLA);
      results[constants.userTypes.user].totalPLA = totalPLA * -1;
    };

    this.getDisregardedAttendanceAllowance = function () {
      var attendanceAllowanceLevels = constants.attendanceAllowance;
      var attendanceAllowanceIncome = userInputModel.getApplicantData().getWeeklyIncome('attendanceAllowance');

      return attendanceAllowanceIncome === attendanceAllowanceLevels.high.amount ?
        attendanceAllowanceLevels.high.amount - attendanceAllowanceLevels.medium.amount : 0;
    };

    this.getDisregardedPrivatePension = function () {
      return 0;
    };

    this.getDisregardedCarersPremium = function (isEntitledToPremium, carersAllowance) {
      var isEntitledToCarersPremium = !!isEntitledToPremium || !!carersAllowance;
      var premium = isEntitledToCarersPremium ? constants.carersPremium : 0;
      console.log("Is entitled to carer's premium", isEntitledToPremium, "carers allowance", carersAllowance, "final premium", premium);
      return premium;
    };

    this.getChildrensPremium = function () {
      var numberOfChildren = userInputModel.dependentChildrenLivingInProperty();
      return numberOfChildren > 0 ? constants.childPremium * numberOfChildren : 0;
    };

    this.getDisregardedPensionSavingsCredit = function (userType, results) {
      var pscAmount = userInputModel.getApplicantData().getWeeklyIncome('pensionSavingsCredit');
      return userInputModel.isCouple() ? pscAmount / 2 : pscAmount;
    };

    this.adjustContribution = function (contributionUpperBound, results) {
      return contributionUpperBound;
    };
  }

  return NonResidentialCareType;
}

NonResidentialCareTypeFactory.$inject = ['kirkleesCareAssessmentConstants', 'numberUtils', 'kirkleesCareAssessmentService', 'careAssessmentService'];

angular.module('kerp-forms.forms').factory('NonResidentialCareType', NonResidentialCareTypeFactory);
